/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TournamentTeamSummary } from './TournamentTeamSummary';
import {
    TournamentTeamSummaryFromJSON,
    TournamentTeamSummaryFromJSONTyped,
    TournamentTeamSummaryToJSON,
    TournamentTeamSummaryToJSONTyped,
} from './TournamentTeamSummary';

/**
 * 
 * @export
 * @interface TournamentTeamsSummaryResponse
 */
export interface TournamentTeamsSummaryResponse {
    /**
     * 
     * @type {Array<TournamentTeamSummary>}
     * @memberof TournamentTeamsSummaryResponse
     */
    teams?: Array<TournamentTeamSummary>;
}

/**
 * Check if a given object implements the TournamentTeamsSummaryResponse interface.
 */
export function instanceOfTournamentTeamsSummaryResponse(value: object): value is TournamentTeamsSummaryResponse {
    return true;
}

export function TournamentTeamsSummaryResponseFromJSON(json: any): TournamentTeamsSummaryResponse {
    return TournamentTeamsSummaryResponseFromJSONTyped(json, false);
}

export function TournamentTeamsSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentTeamsSummaryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'teams': json['teams'] == null ? undefined : ((json['teams'] as Array<any>).map(TournamentTeamSummaryFromJSON)),
    };
}

export function TournamentTeamsSummaryResponseToJSON(json: any): TournamentTeamsSummaryResponse {
    return TournamentTeamsSummaryResponseToJSONTyped(json, false);
}

export function TournamentTeamsSummaryResponseToJSONTyped(value?: TournamentTeamsSummaryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teams': value['teams'] == null ? undefined : ((value['teams'] as Array<any>).map(TournamentTeamSummaryToJSON)),
    };
}

